"use client"
import React, { useEffect, useState } from 'react'
import {ProductCard} from '@/components'
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination, A11y, Autoplay, } from 'swiper/modules';
import { useDispatch, useSelector } from 'react-redux';
import { ToastContainer } from "react-toastify";
import { ProductSkeleton } from './productSkeleton';
import { addToCart } from "@/GlobalRedux/Slices/addToCart";
import { AddToCart, fbConversionAPI, getCartItem } from '@/API/response';
import { getCartItemStart, getCartItemSuccess } from '@/GlobalRedux/Slices/allCartItems';
import { getSessionId } from '@/utils/session';

export const TopProducts = ({filterData}) => {
  // console.log("filter Data",filterData)
  const [IsLoading, setIsLoading] = useState(false)
  const {allProducts,isLoader} = useSelector((state)=> state.allproducts)
  const dispatch = useDispatch()
  const handleAddToCart = async (productId, quantity, price) => {
  
    const getCartProducts = async () => {
          const SessionId = getSessionId()
          // const getSessionId = localStorage.getItem("sessionId")
          try {
            dispatch(getCartItemStart())
            const response = await getCartItem("cart/getCart", SessionId);
            dispatch(getCartItemSuccess(response))
          } catch (error) {
            console.log(error)
          }
        }
    try {
      setIsLoading(true)
      const response =await AddToCart(productId, quantity,"cart/addToCart")
      setIsLoading(false)
      if(response.status == 200){
        dispatch(addToCart(response?.data?.cart?.items))
        getCartProducts()
        const data = {
          eventName:"addToCart",
          eventData :{
           item: response?.data?.cart?.items 
          },
        }
        try {
        const res =  await fbConversionAPI(data,"fb-conversion")
          
        } catch (error) {
        console.log(error)
        }
        if (typeof window !== "undefined" && typeof window.fbq === "function") {
          window.fbq("track", "AddToCart", {
            content_ids: productId,  // REQUIRED: Unique product ID
            content_name: "Product Name",  // OPTIONAL: Product name
            content_type: "product",       // RECOMMENDED: "product" or "product_group"
            value: price,                  // REQUIRED: Price of the product
            currency: "PKR",               // REQUIRED: Currency in ISO format
          });
        }
      }
      else{
        console.log(response.message)
      }
    } catch (error) {
      console.log("error",error)
    }

  };
  
  useEffect(() => {
    const swiper = document.querySelector('.swiper');
    if (swiper) {
      swiper.swiper.navigation.init();
      swiper.swiper.navigation.update();
    }
  }, []);
  return (
    <>
    <Swiper
    modules={[Navigation, Pagination, A11y, Autoplay]}
    spaceBetween={20}
    navigation={{
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    }}
    style={{
      '--swiper-navigation-size': '20px', 
      
    }}
    // pagination={{ clickable: true }}
    autoplay={{ 
      delay: 3000,
      disableOnInteraction: false,
    }}
    breakpoints={{
      340: { slidesPerView: 2 }, // Small screens
      768: { slidesPerView: 2.5 }, // Medium screens
      1024: { slidesPerView: 3.5 }, // Large screens
      // 1280: { slidesPerView: 4.5 }, // Extra-large screens
    }}
    loop
    className="relative w-full   h-full px-2 sm:px-0"
  >
   {
   isLoader ? <ProductSkeleton/> :
   filterData?.map((item, index) => (
        <SwiperSlide key={index} className=" font-sans h-[310px] sm:h-[420px] ">
          <ProductCard id={item._id} url={item.images[0]} url2={item.images[1]? item.images[1] :item.images[0]} title={item.name} price1={item.price} price2={item.comparePrice} onAddToCart={() => handleAddToCart(item._id,1, item?.price)} loading={IsLoading} quantity={item?.quantity}/>
        </SwiperSlide>
      ))}
     <div className="swiper-button-prev bg-gray-400  p-4 hover:p-5 rounded-full text-darkBlack"></div>
     <div className="swiper-button-next bg-gray-400  p-4 hover:p-5 rounded-full text-darkBlack"></div>
   </Swiper>
     <ToastContainer/>
     </>
  )
}
